/* globals window */
import { HashRouter, Route } from 'react-router-dom';

import Cart from 'cart/AppLoader';
import Checkout from 'checkout/AppLoader';
import ClubList from 'club/List';
import ClubRedirect from 'club/SignupRedirect';
import ClubSignup from 'clubSignup/AppLoader';
import {
  getProfileBase,
  getProductBase,
  getReservationBase,
  getCheckoutBase,
  getCollectionBase,
  getCartBase,
  getClubBase
} from 'common/helpers/routerHelper';
import Collection from 'products/CollectionLoader';
import Product from 'products/ProductLoader';
import Profile from 'profile/AppLoader';
import ReservationAvailability from 'reservation/AppLoader';
import ReservationTypeAvailability from 'reservation/TypeAppLoader';
import ReservationCart from 'reservationCart/AppLoader';

import ScrollToTop from './common/components/routes/ScrollToTop';
import URLHistory from './common/components/routes/UrlHistory';

const HashRoutes = () => {
  const { pathname } = window.location;

  const rootPathname = `/${pathname.split('/')[1]}`;

  let routes;

  switch (rootPathname) {
    case getProfileBase():
      routes = <Route component={Profile} />;
      break;
    case getCollectionBase():
      routes = <Route path="/:slug" component={Collection} />;
      break;
    case getProductBase():
      routes = <Route path="/:slug" component={Product} />;
      break;
    case getClubBase():
      routes = (
        <>
          <Route exact path="/" component={ClubList} />
          <Route exact={false} path="/:slug" component={ClubRedirect} />
        </>
      );
      break;
    case getCartBase():
      routes = <Route exact={false} path="/" component={Cart} />;
      break;
    case getReservationBase():
      routes = (
        <>
          <Route exact path="/" component={ReservationAvailability} />
          <Route
            exact={false}
            path="/type/:slug"
            component={ReservationTypeAvailability}
          />
        </>
      );
      break;
    case getCheckoutBase():
      routes = (
        <>
          <Route exact={false} path="/cart" component={Checkout} />
          <Route exact={false} path="/club" component={ClubSignup} />
          <Route
            exact={false}
            path="/reservation"
            component={ReservationCart}
          />
        </>
      );
      break;
    default:
      break;
  }

  return (
    <HashRouter>
      {routes}
      <ScrollToTop />
      <URLHistory />
    </HashRouter>
  );
};

export default HashRoutes;
